import React, { useCallback, } from 'react';
import Chip, { ChipProps, } from '@material-ui/core/Chip';
import { components, } from 'styles';

type DataType = string | ChipProps;

type Props = ChipProps & {
    data: Array<DataType>
};

const Chips: React.FC<Props> = ({
    data,
    classes,
    ...props
}) => {
    const chipClasses = components.makeChipClasses();

    const renderChips = useCallback((item: DataType, index: number) => {
        switch (typeof item) {
            case 'string':
                return (
                    <Chip key={`${item}-${index}`}
                          classes={classes || chipClasses}
                          label={item}
                          {...props} />
                );

            case 'object':
                return (
                    <Chip key={`${item.label}-${index}`}
                          classes={item.classes || classes || chipClasses}
                          {...props}
                          {...item} />
                );

            default:
                return null;
        }
    }, [ props, chipClasses, classes, ]);

    return (
        <>
            {data.map(renderChips)}
        </>
    );
};

Chips.defaultProps = {
    size: 'medium',
};

export default Chips;
